import { List } from 'immutable';
import { __ANY_LINK } from 'customer-data-filters-ui/converters/listSegClassic/ListSegConstants';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'atom... Remove this comment to see the full error message
import { deref, unwatch, watch } from 'atom';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import { isResolved } from 'reference-resolvers/utils';
import FilterOperatorType from 'customer-data-filters-ui/components/propTypes/FilterOperatorType';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceRecord from 'reference-resolvers/schema/ReferenceRecord';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'refe... Remove this comment to see the full error message
import ReferenceResolverSearchType from 'reference-resolvers/schema/ReferenceResolverSearchType';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import { Select } from 'foundations-components/transitional/components/Select';
import memoize from 'transmute/memoize';
import getIn from 'transmute/getIn';
import Raven from 'raven-js';
import { jsx as _jsx } from "react/jsx-runtime";
const _parseListSegAssetId = memoize(operator => {
  const assetName = getIn(['field', 'metadata', 'assetName'], operator) || operator.field.name;
  const assetType = getIn(['field', 'metadata', 'assetType'], operator) || operator.field.type;
  return `${assetName}`.replace(`${assetType}-`, '');
});
class FilterOperatorEmailLinkInput extends Component {
  constructor() {
    // @ts-expect-error ts-migrate(2554) FIXME: Expected 1-2 arguments, but got 0.
    super();
    this.handleChange = ({
      target: {
        value: nextValue
      }
    }) => {
      const {
        fieldName,
        condition,
        onChange
      } = this.props;
      onChange(syntheticEvent(condition.set(fieldName, nextValue)));
    };
    this.handleOptionsChange = options => {
      if (isResolved(options)) {
        this.setState({
          loading: false,
          results: options.get('results').toList()
        });
      }
    };
    this.state = {
      loading: true,
      results: List()
    };
    this.referenceAtom = null;
  }
  componentDidMount() {
    const {
      fieldName,
      condition,
      onChange,
      resolver
    } = this.props;
    const field = condition.get(fieldName);
    if (!field || field === __ANY_LINK) {
      onChange(syntheticEvent(condition.set(fieldName, __ANY_LINK)));
    }
    if (resolver && typeof resolver.search !== 'function') {
      Raven.captureException(new Error(`[Expected a reference resolver] resolver does not have 'search' function; condition.field: ${JSON.stringify(condition.field)}`));
    }
    if (resolver && resolver.search) {
      this.referenceAtom = resolver.search({
        count: 0,
        // Not used
        offset: 0,
        // Not used
        hasMore: false,
        // Not used
        query: _parseListSegAssetId(condition)
      });
      watch(this.referenceAtom, this.handleOptionsChange);
      this.handleOptionsChange(deref(this.referenceAtom));
    }
  }
  componentWillUnmount() {
    if (this.referenceAtom) {
      unwatch(this.referenceAtom, this.handleOptionsChange);
    }
  }
  componentDidUpdate(prevProps) {
    const {
      condition,
      fieldName,
      onChange
    } = this.props;
    const prevField = prevProps.condition.get(fieldName);
    const nextField = condition.get(fieldName);
    if (prevField !== nextField && !nextField) {
      onChange(syntheticEvent(condition.set(fieldName, __ANY_LINK)));
    }
  }
  focus() {
    this.input.focus();
  }

  // @ts-expect-error ts-migrate(7031) FIXME: Binding element 'nextValue' implicitly has an 'any... Remove this comment to see the full error message

  render() {
    const {
      condition,
      fieldName,
      inputUse
    } = this.props;
    const {
      loading,
      results
    } = this.state;
    const anyLinkOption = {
      text: I18n.text('customerDataFiltersUI.customerDataFilters.FilterEditor.specialOptionValues.anyLink'),
      value: __ANY_LINK
    };
    const error = loading ? false : undefined;
    return /*#__PURE__*/_jsx(Select, {
      buttonUse: inputUse === 'on-dark' ? 'form-on-dark' : undefined,
      defaultValue: __ANY_LINK,
      error: error,
      onChange: this.handleChange,
      options: [anyLinkOption, ...ReferenceRecord.toOptionsArray(results)],
      ref: component => {
        this.input = component;
      }
      //@ts-expect-error `get` returns `unknown` type
      ,
      value: condition.get(fieldName)
    });
  }
}
FilterOperatorEmailLinkInput.defaultProps = {
  fieldName: 'value'
};
FilterOperatorEmailLinkInput.propTypes = {
  condition: FilterOperatorType.isRequired,
  fieldName: PropTypes.string.isRequired,
  inputUse: PropTypes.oneOf(['on-dark']),
  onChange: PropTypes.func.isRequired,
  resolver: ReferenceResolverSearchType.isRequired
};
export default FilterOperatorEmailLinkInput;